import apiCall from '@/utils/apiCall';

export default {
    /**
     * Loads products.
     *
     * @param  {object}    store        Vuex store.
     * @param  {object}    store.state  Vuex state.
     * @param  {Function}  store.commit Method to commit a mutation.
     */
    async loadProducts({ commit, state }, { force = false } = {}) {
        if (state.products && ! force) {
            return;
        }

        const { status, data } = await apiCall(this._vm, 'get', '/api/billing/products');

        if (200 === status) {
            commit('setProducts', data);
        } else {
            commit('setProducts', false);
        }
    },
};
